
import { apiEndPoints } from "../../ApiServices/config";
import { postApi } from "../../ApiServices/api";
import toast from "react-hot-toast";
import { useState } from "react";
import { useRef } from "react";

function useLoadContactus(reset){
    const recaptchaRef = useRef(null);
    const [recaptchaToken, setRecaptchaToken] = useState("");

    const onSubmit = async (data) => {
        data.recaptchaReactive = recaptchaToken;
    
        try {
          const response = await postApi(apiEndPoints.contactUs, data);
          if (response.data.status === 1) {
            toast.success(response.data.message);
            reset();
          }
        } catch (error) {
          console.log(error);
          toast.error(`"Something Went Wrong"`);
        }
      };
    
      const handleRecaptchaChange = (token) => {
        setRecaptchaToken(token);
      };

      return {
        onSubmit,
        handleRecaptchaChange,
        recaptchaRef,
        recaptchaToken,
      }

}

export default useLoadContactus;